import {Provider} from 'react-redux'
import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'

import store, {persistor} from '../redux/store'
import {PersistGate} from 'redux-persist/integration/react'
import {Toaster} from 'react-hot-toast'
import ModalLoading from 'app/components/Ops/ModalLoading'
import {ModalProvider} from './components/Ops/ModalConfirm'
import {ChangePasswordProvider} from './components/Ops/ChangePassword'
import {ConfigProvider} from 'antd'

import dayjs from 'dayjs'
import 'dayjs/locale/id' // Import locale Indonesia
import locale from 'antd/lib/locale/id_ID' // Import locale Ant Design untuk Indonesia

// Set locale ke Indonesia
dayjs.locale('id')

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<LayoutSplashScreen />}>
          <I18nProvider>
            <LayoutProvider>
              <ModalProvider>
                <ChangePasswordProvider>
                  <ConfigProvider locale={locale}>
                    <AuthInit>
                      <Toaster />
                      <Outlet />
                      <ModalLoading />
                      <MasterInit />
                    </AuthInit>
                  </ConfigProvider>
                </ChangePasswordProvider>
              </ModalProvider>
            </LayoutProvider>
          </I18nProvider>
        </Suspense>
      </PersistGate>
    </Provider>
  )
}

export {App}
